import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_SUBMISSION_SURPLUS_LINE = graphql(`
  query getSubmissionSurplusLine($uuid: String!) {
    submission(uuid: $uuid) {
      uuid
      surplusLinesLicenseeInfo
    }
  }
`);

export function useSubmissionSurplusLineQuery(uuid: string | undefined) {
  const { loading, error, data, refetch } = useQuery(
    GET_SUBMISSION_SURPLUS_LINE,
    {
      variables: { uuid: uuid ?? '' },
      fetchPolicy: 'no-cache',
      skip: !uuid,
    }
  );

  return {
    loading,
    error,
    data,
    refetch,
  };
}
